import { Course } from 'redux/schemas/models/course';
import { MentoringProgram } from 'redux/schemas/models/mentoring-programs';


export enum OfferingTypes {
  COURSE = 'course',
  JOURNEY = 'journey',
  MENTORSHIP_PROGRAM = 'mentorship_program',
}

export type CourseOrMentorshipProgram =
| Partial<Course> & { type: OfferingTypes.COURSE | OfferingTypes.JOURNEY }
| Partial<MentoringProgram> & { type: OfferingTypes.MENTORSHIP_PROGRAM, enrolledUsersCount: number, catalogId?: string };
